"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStoreError = exports.useStore = exports.useStoreErrorSubscription = exports.useStoreSubcription = void 0;
var react_1 = require("react");
/**
 * @param {Store} store  - Store to subscribe.
 * @param {Function} callback - Function to call on each dipatch.
 * @param {Function} errorCallback - Function to call on each error dipatch.
 */
function useStoreSubcription(store, callback, errorCallback) {
    var callbacksRef = (0, react_1.useRef)({
        callback: callback,
        errorCallback: errorCallback,
    });
    callbacksRef.current = {
        callback: callback,
        errorCallback: errorCallback,
    };
    var hasCallBack = Boolean(callback);
    var hasErrorCallBack = Boolean(errorCallback);
    (0, react_1.useEffect)(function () {
        if (!hasCallBack) {
            return;
        }
        var unsubscribe = store.subscribe(function (data) {
            if (callbacksRef.current.callback) {
                callbacksRef.current.callback(data);
            }
        });
        return function () {
            unsubscribe.unsubscribe();
        };
    }, [store, hasCallBack]);
    (0, react_1.useEffect)(function () {
        if (!hasErrorCallBack) {
            return;
        }
        var unsubscribe = store.subscribeError(function (data) {
            if (callbacksRef.current.errorCallback) {
                callbacksRef.current.errorCallback(data);
            }
        });
        return function () {
            unsubscribe.unsubscribe();
        };
    }, [store, hasErrorCallBack]);
}
exports.useStoreSubcription = useStoreSubcription;
/**
 * @param {Store} store  - Store to subscribe.
 * @param {Function} errorcCallback - Function to call on each error dipatch.
 */
function useStoreErrorSubscription(store, errorcCallback) {
    var callbacksRef = (0, react_1.useRef)({
        errorcCallback: errorcCallback,
    });
    callbacksRef.current = {
        errorcCallback: errorcCallback,
    };
    (0, react_1.useEffect)(function () {
        var unsubscribeError = store.subscribeError(function (data) {
            if (callbacksRef.current.errorcCallback) {
                callbacksRef.current.errorcCallback(data);
            }
        });
        return function () {
            unsubscribeError.unsubscribe();
        };
    }, [store]);
}
exports.useStoreErrorSubscription = useStoreErrorSubscription;
/**
 * @param {Store} store - Store to subscribe.
 * @returns {Object} - Resulto object from the store.
 */
function useStore(store) {
    var _a = (0, react_1.useState)(store.get()), state = _a[0], setState = _a[1];
    useStoreSubcription(store, function (data) {
        setState(data);
    });
    return state;
}
exports.useStore = useStore;
/**
 * @param {Store} store - Store to subscribe.
 * @returns {Object} - Resulto object from the store.
 */
function useStoreError(store) {
    var _a = (0, react_1.useState)(null), state = _a[0], setState = _a[1];
    useStoreErrorSubscription(store, function (data) {
        setState(data);
    });
    return state;
}
exports.useStoreError = useStoreError;
